import React, { useState } from 'react';
import GroupEditor from "../GroupEditor";
import useLocalStorage from "../../hooks/useLocalStorage";

function LongestIncreasingSubsequence() {
    const [script, setScript] = useLocalStorage('longestIncreasingSubsequenceScript', `function longestIncreasingSubsequence(arr) {
  let lengths = Array(arr.length).fill(1);
  let previous = Array(arr.length).fill(-1);
  for (let i = 1; i < arr.length; i++) {
    for (let j = 0; j < i; j++) {
    }
  }
  let maxLength = 0;
  let maxIndex = 0;
  for (let i = 0; i < arr.length; i++) {
  }
  let result = [];
  while (maxIndex !== -1) {
    result.push(arr[maxIndex]);
    maxIndex = previous[maxIndex];
  }
  return result;
}
`);
    const [resultText, setResultText] = useState('');
    const [syntaxError, setSyntaxError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [resultTextCss, setResultTextCss] = useState('');
    const [srcDoc, setSrcDoc] = useState('');
    const [showHint, setShowHint] = useState(false);

    const testArrays = [
        [10, 22, 9, 33, 21, 50, 41, 60],
        [3, 10, 2, 1, 20],
        [3, 2],
        []
    ];

    function calculateCorrectResult(arr) {
        if (arr.length === 0) return [];
        let lengths = Array(arr.length).fill(1);
        let previous = Array(arr.length).fill(-1);
        for (let i = 1; i < arr.length; i++) {
            for (let j = 0; j < i; j++) {
                if (arr[i] > arr[j] && lengths[i] < lengths[j] + 1) {
                    lengths[i] = lengths[j] + 1;
                    previous[i] = j;
                }
            }
        }
        let maxLength = 0;
        let maxIndex = 0;
        for (let i = 0; i < arr.length; i++) {
            if (lengths[i] > maxLength) {
                maxLength = lengths[i];
                maxIndex = i;
            }
        }
        let result = [];
        while (maxIndex !== -1) {
            result.push(arr[maxIndex]);
            maxIndex = previous[maxIndex];
        }
        return result.reverse();
    }

    const correctResults = testArrays.map(arr => calculateCorrectResult(arr));

    function executeScript() {
        setSyntaxError(false);
        setErrorMessage('');
        setResultText('');
        try {
            const results = testArrays.map(arr => {
                const scriptFunction = new Function(`
                    let output = [];
                    const input = ${JSON.stringify(arr)};
                    function print(text) {
                      output.push(text.toString());
                    }
                    ${script}
                    const userResult = longestIncreasingSubsequence(input);
                    print(JSON.stringify(userResult));
                    return output[0] || "";
                    `);
                const resultStr = scriptFunction();
                return JSON.parse(resultStr);
            });
            const formattedOutput = testArrays.map((arr, index) =>
                `<div>Input: ${JSON.stringify(arr)} - Ausgabe: ${JSON.stringify(results[index])}</div>`
            ).join('');
            setSrcDoc(`<!DOCTYPE html><html><body>${formattedOutput}</body></html>`);
            checkPassed(results);
        } catch (e) {
            setSyntaxError(true);
            setResultTextCss('');
            setResultText("Ergebnis kann nicht ausgewertet werden, da dein Code noch einen oder mehrere Syntaxfehler hat:");
            setErrorMessage(e.message);
            setSrcDoc(`<div style="color: red;">Fehler: ${e.message}</div>`);
        }
    }

    function checkPassed(results) {
        for (let i = 0; i < testArrays.length; i++) {
            const res = results[i];
            const correct = correctResults[i];
            if (!Array.isArray(res) || res.length !== correct.length) {
                setResultTextCss('error-message');
                setResultText(`Deine Lösung ist falsch. Fehler bei Input: ${JSON.stringify(testArrays[i])}. Erwartete Länge: ${correct.length}, dein Ergebnis: ${JSON.stringify(res)}.`);
                return;
            }
      for (let j = 0; j < res.length - 1; j++) {
        if (res[j] >= res[j + 1]) {
          setResultTextCss('error-message');
          setResultText(`Deine Lösung ist falsch. Die Folge ${JSON.stringify(res)} ist nicht streng aufsteigend.`);
          return;
        }
      }
    }
    setResultTextCss('success-result');
    setResultText("Deine Lösung ist korrekt!");
  }

  return (
      <>
          <div className="aufgaben-container">
              <h2>Längste aufsteigende Teilfolge</h2>
              <h3>Aufgabenstellung:</h3>
              Implementiert ist hier die Funktion <code>longestIncreasingSubsequence</code>, welcher leider noch nicht
              Vollständig ist. Deine Aufgabe ist es die Funktion zu Vervollständigen, so dass den der Eingabe des Arrays
              'arr', die längste dich darin befindende, aufsteigende Teilmenge zurückgegeben wird. Die Teilfolge muss in
              der gleichen Reihenfolge wie im Eingabearray vorkommen. Falls es mehrere Lösungen gibt, gib eine beliebige
              zurück.
              <p></p> Die eingabe des Arrays '[1,5,3,7,4,5]' soll also '[1,3,4,5]' zurückgeben.
              <p>Wichtig: es muss ein Array zurückgegeben werden</p>
              <p>Tipp: Versuche als erstes Testcase 4 abzufangen</p>
          </div>
          <div className="aufgaben-container">
              <GroupEditor
                  language="javascript"
                  value={script}
                  onChange={setScript}
                  editorKey="longestIncreasingSubsequenceScript"
              />
          </div>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                  <button className="submit-code-button" onClick={executeScript}>▶ Code ausführen</button>
                  <div style={{ display: 'flex', gap: '5px' }}>
                      {testArrays.map((arr, index) => (
                          <div key={index} style={{
                              border: '1px solid #ccc',
                              padding: '5px 10px',
                              borderRadius: '4px',
                              backgroundColor: '#f9f9f9'
                          }}>
                              Testcase {index + 1}: {JSON.stringify(arr)}
                          </div>
                      ))}
                  </div>
              </div>
              <button className="hint-button" onClick={() => setShowHint(!showHint)}>
                  {showHint ? 'Hinweis ausblenden' : 'Hinweis einblenden'}
              </button>
          </div>
          {showHint && (
              <div style={{
                  marginTop: '10px',
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  backgroundColor: '#eef'
              }}>
                  <strong>Hinweis:</strong> Überlege, wie du dynamische Programmierung einsetzen kannst, um für jedes Element im Array die Länge der längsten aufsteigenden Teilfolge zu berechnen.
              </div>
          )}
          <div className="ergebnis-text">
              Ergebnis: <br/>
              <div className={resultTextCss}>{resultText}</div>
              {syntaxError && <div className="error-message">{errorMessage}</div>}
          </div>
          <div className="result-frame">
              <iframe
                  title="console-output"
                  srcDoc={srcDoc}
                  sandbox="allow-scripts"
                  width="100%"
                  height="40%"
              />
          </div>
      </>
  );
}

export default LongestIncreasingSubsequence;
